import Grid from "@mui/material/Grid";
import BonusXLoading from "./BonusXLoading";

export function Loading(): JSX.Element {
  return (
    <Grid container alignItems="center" data-testid="loading" css={{ height: "100%" }}>
      <Grid container justifyContent="center">
        <BonusXLoading />
      </Grid>
    </Grid>
  );
}
